import { getPublisherByType } from '../publishers/publishers';
import { BI_BASE_URL, PERFORMANCE_BASE_URL } from '../conf';

export default class Reporter {
  constructor(
    baseUrl = BI_BASE_URL,
    performanceBaseUrl = PERFORMANCE_BASE_URL,
    publisher,
  ) {
    this.baseUrl = baseUrl;
    this.performanceBaseUrl = performanceBaseUrl;
    this.mainUrl = this.baseUrl;
    this.publisher = publisher;

    if (!this.publisher) {
      this.publisher = getPublisherByType();
    }
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  getPublisher() {
    return this.publisher;
  }

  useBaseUrl() {
    this.mainUrl = this.baseUrl;
  }

  usePerformanceUrl() {
    this.mainUrl = this.performanceBaseUrl;
  }

  report(data) {
    if (!data) {
      return null;
    }

    return this.publisher(this.mainUrl, data);
  }
}
